<template>
    <span :data-balloon="tooltip || 'Click to see the data sheet'" data-balloon-pos="up" class="modal-container">
        <a href :class="linkClasses" @click.stop.prevent="open" v-text="text"></a>

        <div class="remodal" :data-remodal-id='modalID'>
            <div class="modal">
                <object :data="result" type="application/pdf" width="100%" height="500px" v-if="active">
                    <p class="meta coach">This browser does not support inline PDFs. Please download the PDF to view it. <a :href="`${result}?&download=1`">Download PDF</a></p>
                </object>
            </div>
            <button data-remodal-action="close" class="remodal-close simple"></button>
        </div>
    </span>
</template>

<script>
    import Modal from 'vue/common/_modal'

    export default {
        extends: Modal,
        props: ['link-classes', 'index', 'text', 'tooltip'],
        computed: {
            modalID() {
                let urlSlug = ('' + this.result)
                    .replace(new RegExp('^https?://[^/]*'), '')
                    .replace(/[^\w-]+/g, '-')
                    .replace(/^-*/, '');

                return (this.index !== false) ? this.index + '-' + urlSlug : urlSlug;
            },
        },
    }
</script>
